import { useQuery } from 'react-query';

import { getLongestAddedActivities as queryFn } from 'api/endPoints/getLongestAddedActivities';

export const useQueryLargestAddedActivitiesTableData = (params) => {
    return useQuery(['largestAddedActivitiesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
